import { func, string } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import i18next from 'i18next';

import useCheckStoreOpen from '~hooks/useCheckStoreOpen';
import { DATA_TEST_ID } from '~constants/tests';
import { DISPATCH_METHODS } from '~constants/address';
import Text from '~components/Text';

import NowOrLaterButton from '../NowOrLaterButton';

import styles from './styles.module.scss';

const Address = ({ handleOpenDAPModal, dispatchType, address, currentSubsidiary }) => {
  const { futureOrdersEnabled } = useCheckStoreOpen();
  const { templateModel } = useSelector((state) => state.core);
  return (
    <div className={cn('row middle center', styles[`addressOrStoreBar${templateModel}`])}>
      <div
        className={cn('row middle full-width', {
          'space-between': futureOrdersEnabled
        })}>
        <span className={cn('m-right-2 material-icons-outlined', styles[`iconLink${templateModel}`])}>
          location_on
        </span>

        <Text
          data-testid={DATA_TEST_ID.deliveryOrPickupSelector}
          onClick={handleOpenDAPModal}
          className={styles[`${address ? `address${templateModel}` : 'enterAddress'}`]}>
          {address
            ? dispatchType === DISPATCH_METHODS.DELIVERY
              ? address
              : currentSubsidiary
            : i18next.t('AddressInput:whereDoYouWantToOrderToday')}
        </Text>
        {futureOrdersEnabled && <NowOrLaterButton templateModel={templateModel} />}
      </div>
    </div>
  );
};

Address.propTypes = {
  address: string,
  currentSubsidiary: string,
  dispatchType: string,
  handleOpenDAPModal: func
};

export default Address;
